import React from "react";

import { SkeletonImage } from "./skeleton-patterns/SkeletonImage";

export interface ImageCardProps extends React.HTMLAttributes<HTMLDivElement> {
  status: "loading" | "ready" | "error";
  aspectRatio?: string;
  loadingLabel?: string;
  errorContent?: React.ReactNode;
}

/** Presentation only: fetching, retrying and URL authorization belong to the consumer. */
export function ImageCard({
  status,
  aspectRatio = "1",
  loadingLabel = "Loading image",
  errorContent = "Image unavailable",
  children,
  style,
  ...props
}: ImageCardProps) {
  return (
    <div
      {...props}
      aria-busy={status === "loading"}
      style={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        aspectRatio,
        ...style,
      }}
    >
      {status === "loading" ? (
        <SkeletonImage width="100%" height="100%" aria-label={loadingLabel} />
      ) : status === "error" ? (
        <div
          role="status"
          style={{ display: "grid", placeItems: "center", height: "100%" }}
        >
          {errorContent}
        </div>
      ) : (
        children
      )}
    </div>
  );
}

export interface ImageGalleryProps
  extends React.HTMLAttributes<HTMLDivElement> {
  minCardWidth?: number;
  gap?: number;
}

export function ImageGallery({
  minCardWidth = 180,
  gap = 12,
  style,
  ...props
}: ImageGalleryProps) {
  return (
    <div
      {...props}
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fit,minmax(min(100%,${minCardWidth}px),1fr))`,
        gap,
        ...style,
      }}
    />
  );
}
